import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsertImageV2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		transform: "translate(-4)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 24,
			rx: 2
		}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			fill: "#475464",
			fillRule: "nonzero",
			d: "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z",
			transform: "translate(4)"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M0 0L24 0 24 24 0 24z",
			transform: "translate(4)"
		})] })]
	})
});
export default SvgInsertImageV2;
